import { useMemo } from "react";
import type { ReactNode } from "react";
import { FormControlLabel, FormGroup, Switch, useTheme } from "@mui/material";
import type { SxProps } from "@mui/material";
import { useInfo } from "providers/InfoBullesProvider";
import { getHelpIconInfoSwitchStyles } from "./styles";

interface InfoSwitchProps {
  infoKey: string;
  sx?: SxProps;
}

/**
 * Permet d'afficher/cacher le/les InfoBulle associées (avec la même infoKey).
 * Doit être à l'intérieur d'un InfoBulleProvider.
 * @param {string} infoKey clé permettant de faire le lien entre ce composant et les InfoBulle associées
 */
function InfoBulleSwitch({ infoKey, sx }: Readonly<InfoSwitchProps>): ReactNode {
  const { getInfoBulleSwitch, setInfoBulleSwitch } = useInfo();

  const theme = useTheme();
  const helpIconInfoSwitchStyles = getHelpIconInfoSwitchStyles(theme);

  const checked = useMemo(() => getInfoBulleSwitch(infoKey), [getInfoBulleSwitch, infoKey]);

  return (
    <FormGroup sx={sx} row>
      <FormControlLabel
        control={
          <Switch
            color="info"
            sx={helpIconInfoSwitchStyles}
            checked={checked}
            onChange={(_e, checked) => {
              setInfoBulleSwitch(infoKey, checked);
            }}
          />
        }
        label="Aide"
        labelPlacement="start"
      />
    </FormGroup>
  );
}

export default InfoBulleSwitch;
